<template>
  <svg
    width="14"
    height="13"
    viewBox="0 0 14 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.9574 0.9375L5.54258 9.22232L1.75 5.50982L0 7.22411L5.83242 12.9375L14 2.65179L11.9574 0.9375Z"
      fill="white"
    />
  </svg>
</template>

<script>
export default {};
</script>

<style></style>
